import { render, staticRenderFns } from "./OrderSubmissionForm.vue?vue&type=template&id=4b79156e&"
import script from "./OrderSubmissionForm.vue?vue&type=script&lang=js&"
export * from "./OrderSubmissionForm.vue?vue&type=script&lang=js&"
import style0 from "./OrderSubmissionForm.vue?vue&type=style&index=0&id=4b79156e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports